import { render, staticRenderFns } from "./tuantiSole.vue?vue&type=template&id=35c82a9a&scoped=true"
import script from "./tuantiSole.vue?vue&type=script&lang=js"
export * from "./tuantiSole.vue?vue&type=script&lang=js"
import style0 from "./tuantiSole.vue?vue&type=style&index=0&id=35c82a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c82a9a",
  null
  
)

export default component.exports